import { MoreOutlined, PlusOutlined, SearchOutlined } from "@ant-design/icons";
import {
  Button,
  Card,
  Col,
  Input,
  Popover,
  Row,
  Skeleton,
  Table,
  Tooltip,
} from "antd";
import React, { useContext } from "react";
// import { useTheme } from "../../../Context/ThemeContext";
import { ColumnsType } from "antd/es/table";
import { useTheme } from "../../Context/ThemeContext";
import { useClient } from "../../Context/ClientContext";
import { Party_Tax } from "../../Services/VoucherServices";
import LedgerService, {
  LedgerStatus,
  SearchLedgerByGroupsTypes,
} from "../../Services/LedgerService";
import { useKeyboardShortcuts } from "../../Common/KeyboardShortcuts ";
import { AdjustBankType } from "./Banks/AdjustBankBalanceModel";
import AddBankAccountModel from "./Banks/AddBankAccountModel";
import AddChequeBookModal from "./Banks/AddChequeBookModal";
import ChequeBooksTable from "./Banks/ChequeBooksTable";
import { Utils } from "../../../Utilities/Utils";
import { ConfirmationModal } from "../../Common/ConfirmationModal";
import { notificationContext } from "../../Common/PageRoute";

interface IAllBankListDataType {
  key: string;
  id: string;
  currentBalance: number;
  ledgerName: string;
  sno: string;
  partyOrTax: Party_Tax;
  system: LedgerStatus;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
interface IbankTransactionsDataType {
  key: string;
  date: string;
  description: string;
  transactionType: string;
  refNo: {
    id: number;
    name: string;
    type: number;
  };
  amount: number;
  balance: number;
}

const Cheque: React.FC = () => {
  const { themeData } = useTheme();
  const { currentClient } = useClient();
  const [bankTotalRecords, setBankTotalRecords] = React.useState<number>(0);
  const [confirmation, setConfirmation] = React.useState<boolean>(false);
  const [bankLoading, setBankLoading] = React.useState<boolean>(false);
  const { openNotification } = useContext(notificationContext);
  const [bankTrigger, setBankTrigger] = React.useState<boolean>(false);
  const [bankList, setBankList] = React.useState<any[]>([]);
  const [searchBank, setSearchBank] = React.useState<any>();
  const [pageInv, SetPageInv] = React.useState<number>(1);
  const [pageItem, setPageItem] = React.useState<number>(1);
  const [bank, setBank] = React.useState<{
    id: string;
    name: string;
    partyOrTax: Party_Tax;
  }>({
    id: "",
    name: "",
    partyOrTax: Party_Tax.other,
  });
  const [filterOption, setFilterOption] = React.useState<{
    gstRate: number[];
    partyType: number;
    iState: number;
  }>({
    gstRate: [],
    partyType: 0,
    iState: 0,
  });
  const [openModel, setOpenModel] = React.useState<{
    type: string;
    param: any;
  }>({
    type: "",
    param: {},
  });
  const [bankAccountDetails, setBankAccountDetails] = React.useState<any>({});
  const [filterOrder, setFilterOrder] = React.useState<any>({
    sortCol: "",
    sortDir: "",
  });

  const [openbankAccountPopArray, setOpenBankAccountNoPopArray] =
    React.useState<boolean[]>([]);
  const [refresh, setRefresh] = React.useState<boolean>(false);
  const [refreshData, setRefreshData] = React.useState<boolean>(false);

  //----- Bank Account Table List -----
  React.useEffect(() => {
    if (currentClient?.id) {
      GetLedgersByGroupTypes(currentClient?.id, searchBank);
    } else {
      console.error("currentClient is null Items");
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    // props.bankTrigger,
    bankTrigger,
    pageInv,
    pageItem,
    searchBank,
    filterOrder.sortCol,
    filterOrder.sortDir,
    filterOption.gstRate,
    refreshData,
  ]);

  // --------- Get All BankAccount Table Data  API ---------
  const GetLedgersByGroupTypes = async (clientId: string, search?: string) => {
    setBankLoading(true);
    await LedgerService?.getLedgersByGroupName(
      clientId,
      SearchLedgerByGroupsTypes?.BankOnly,
      searchBank
    )
      .then((res: any) => {
        if (res.length > 0) {
          setBankList(
            res?.map((v: any, i: any) => {
              return {
                parent: v?.parent,
                ledgerName: v?.ledgerName,
                id: v?.id,
                bankDetail: v?.bankDetail !== null ? v?.bankDetail[0] : [{}],
                balance: v?.balance,
                partyOrTax: v?.partyOrTax,
                system: v?.system,
              };
            })
          );

          !bank.id &&
            setBank({
              id: res[0].id,
              name: res[0].ledgerName,
              partyOrTax: res[0].partyOrTax,
            });
          setBankTotalRecords(res?.length);
        } else if (res.length === 0) {
          setBankList([]);
          setBankTotalRecords(res?.bankTotalRecords);
        }
        setBankLoading(false);
      })
      .catch((ex: any) => {
        console.error(ex.message);
        setBankLoading(false);
        setBankList([]);
      });
  };

  const bankAccountPopoverOnchange = (
    columnIndex: number,
    newOpen: boolean
  ) => {
    const updatedOpenPopArray = [...openbankAccountPopArray];
    updatedOpenPopArray[columnIndex] = newOpen;
    setOpenBankAccountNoPopArray(updatedOpenPopArray);
  };

  const deleteLedger = async () => {
    let res = await LedgerService.deleteLedgerMaster(
      currentClient?.id,
      bank?.id
    );
    if (res?.status) {
      setConfirmation(false);
      openNotification("success", "Ledger deleted sucessfully.");
      setRefreshData((x: boolean) => !x);
    } else {
      setConfirmation(false);
      openNotification("error", res.message);
    }
  };

  // --------- Bank Account Table Columns  ---------
  const bankColomns: ColumnsType<IAllBankListDataType> = [
    {
      title: "Account Name",
      dataIndex: "ledgerName",
      key: "id",
      render: (_, record, index: number) => (
        <Skeleton
          active
          loading={bankLoading}
          paragraph={{ rows: 1 }}
          title={false}
        >
          <Row>
            <Col span={23} style={{ cursor: "pointer" }}>
              <div
                onClick={() => {
                  setBank({
                    id: record.id,
                    name: record.ledgerName,
                    partyOrTax: record?.partyOrTax,
                  });
                }}
                style={{
                  cursor: "pointer",
                  color: "black",
                }}
              >
                {record.ledgerName}
              </div>
            </Col>
            <Col span={1}>
              <Popover
                trigger="click"
                placement="bottom"
                arrow={{ pointAtCenter: true }}
                open={openbankAccountPopArray[index]}
                // arrow={{ pointAtCenter: true }}
                onOpenChange={(newOpen) =>
                  bankAccountPopoverOnchange(index, newOpen)
                }
                // onOpenChange={(x: boolean) =>
                //   setPopoverOpen({ ...filter, inventoryTable: x })
                // }
                content={
                  <Row style={{ maxWidth: "100px" }}>
                    <Col lg={24}>
                      <Tooltip
                        title={
                          record?.system
                            ? "Default ledger are not editable"
                            : ""
                        }
                        placement="top"
                        color={record?.system ? "rgb(216 207 207)" : ""}
                      >
                        <Button
                          style={{ width: 100 }}
                          onClick={() => {
                            setOpenModel({
                              type: "addBankAccount",
                              param: {
                                id: record?.id,
                              },
                            });
                            bankAccountPopoverOnchange(index, false);
                          }}
                          disabled={record?.system ? true : false}
                        >
                          Edit
                        </Button>
                      </Tooltip>
                    </Col>

                    <Col lg={24} style={{ marginTop: "6px" }}>
                      <Button
                        style={{ width: 100 }}
                        disabled={record?.system ? true : false}
                        onClick={() => {
                          setBank({
                            id: record.id,
                            name: record.ledgerName,
                            partyOrTax: record?.partyOrTax,
                          });
                          setConfirmation(true);
                        }}
                      >
                        Delete
                      </Button>
                    </Col>
                  </Row>
                }
              >
                <MoreOutlined style={{ fontSize: "16px" }} />
              </Popover>
            </Col>
          </Row>
        </Skeleton>
      ),
    },
  ];

  //------- Get Bank Account Details -------
  React.useEffect(() => {
    if (bank?.id) {
      // setModelLoading(true);
      const get = async (id: string) => {
        await setBankAccountDetails(bankList.find((x) => x.id === bank?.id));
      };
      get(bank.id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bank?.id]);

  // ----- Short-Cut for Open Model -----F
  useKeyboardShortcuts("N", ["shiftKey"], () => {
    setOpenModel({
      type: "addBankAccount",
      param: {
        id: "",
        type: "",
      },
    });
  });

  return (
    <div>
      {/* //tabbackground */}
      <div
        style={{
          // borderRadius: "8px",
          marginTop: 7,
          // backgroundColor: "white",
          padding: "10px 0px 0px 0px",
          // boxShadow: "0px 0px 10px 0px #96A1C84D",
        }}
      ></div>
      <Row style={{ marginTop: "0px" }}>
        <Col lg={6} style={{ paddingRight: "5px", paddingTop: "7px" }}>
          <Card
            className="ca-card-body"
            style={{ boxShadow: "0px 0px 10px 0px #96A1C84D" }}
          >
            <div>
              <Row
                align="middle"
                justify="space-around"
                style={{ borderBottom: "1px solid #DFE9F7" }}
              >
                <Col lg={15}>
                  <Input
                    allowClear={true}
                    // width: "220px",
                    style={{ margin: "5px 0px 5px 0px" }}
                    placeholder="Search.."
                    onChange={(e: any) => {
                      setBankLoading(true);
                      if (!e.cancelable) {
                        const searchBank = setTimeout(() => {
                          SetPageInv(1);
                          setSearchBank(e.target.value);
                        }, 1000);
                        return () => clearTimeout(searchBank);
                      } else {
                        setSearchBank(e.target.value);
                      }
                    }}
                    suffix={bankLoading || searchBank ? "" : <SearchOutlined />}
                  />
                </Col>
                {/* style={{ marginLeft: "8px" }} */}
                <Col lg={7}>
                  <Button
                    className="customButtonCss"
                    type="primary"
                    id=""
                    icon={<PlusOutlined />}
                    onClick={() => {
                      setOpenModel({
                        type: "addBankAccount",
                        param: {
                          id: "",
                          type: "",
                        },
                      });
                    }}
                  >
                    Bank
                  </Button>
                </Col>
              </Row>
            </div>
            <div
              style={{
                maxHeight: "100%",
                overflowY: "auto",
                position: "relative",
              }}
            >
              <Table
                rowClassName={(record, index) => {
                  return record.id === bank.id ? "ca-active-table" : "";
                }}
                className={`Tabel-style-none table-${
                  themeData?.componentSize ?? "middle"
                }`}
                // showHeader={false}
                // rowSelection={rowSelection}
                columns={bankColomns}
                dataSource={
                  bankLoading
                    ? (Array.from({ length: 20 }, (_, index) => ({
                        key: `loading-${index}`,
                      })) as IAllBankListDataType[])
                    : bankList
                }
                pagination={false}
                footer={() => (
                  <>
                    <div
                      style={{
                        position: "sticky",
                        bottom: 0,
                        backgroundColor: "#F5F8FF",
                      }}
                    >
                      <table>
                        <tbody>
                          <tr>
                            <th className="textStart">Total Bank Account(s)</th>
                            <th style={{}}>{bankTotalRecords}</th>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </>
                )}
              />
            </div>
          </Card>
        </Col>

        <Col
          lg={18}
          style={{ paddingLeft: "5px", paddingTop: "7px" }}
          className="ca-card-body-padding"
        >
          <Card
            style={{
              marginBottom: "10px",
              boxShadow: "0px 0px 10px 0px #96A1C84D",
            }}
          >
            <Row>
              <Col span={6}>
                <div>
                  {bankAccountDetails.ledgerName?.length > 30 ? (
                    <Tooltip
                      title={bankAccountDetails?.ledgerName}
                      placement="top"
                      color="#3D4998"
                    >
                      {bankAccountDetails?.ledgerName.slice(0, 30) + "..."}
                    </Tooltip>
                  ) : (
                    <>
                      <span
                        style={{
                          paddingRight: "10px",
                          color: "rgb(139, 143, 165)",
                        }}
                      >
                        Ledger:
                      </span>
                      {bankAccountDetails?.ledgerName}
                    </>
                  )}
                </div>
                <div>
                  <span
                    style={{
                      paddingRight: "10px",
                      color: "rgb(139, 143, 165)",
                    }}
                  >
                    Account Type:
                  </span>
                  {bankAccountDetails?.bankDetail?.accountType === 1
                    ? "Saving Account"
                    : bankAccountDetails?.bankDetail?.accountType === 2
                    ? "Current Account"
                    : bankAccountDetails?.bankDetail?.accountType === 3
                    ? "Credit Card"
                    : ""}
                </div>
              </Col>
              <Col span={7}>
                <div>
                  <span
                    style={{
                      paddingRight: "10px",
                      color: "rgb(139, 143, 165)",
                    }}
                  >
                    Balance:
                  </span>
                  {bankAccountDetails?.balance === 0
                    ? 0
                    : bankAccountDetails?.balance > 0
                    ? Utils.getFormattedNumber(bankAccountDetails?.balance) +
                      " Dr"
                    : Utils.getFormattedNumber(
                        Math.abs(bankAccountDetails?.balance)
                      ) + " Cr"}
                </div>
                <div>
                  <span
                    style={{
                      paddingRight: "14px",
                      color: "rgb(139, 143, 165)",
                    }}
                  >
                    A/c No.:
                  </span>
                  {bankAccountDetails?.bankDetail?.accountNumber!}
                  {bankAccountDetails.accountNumber?.length > 23 ? (
                    <Tooltip
                      title={bankAccountDetails?.accountNumber}
                      placement="top"
                      color="#3D4998"
                    >
                      {bankAccountDetails?.accountNumber.slice(0, 23) + "..."}
                    </Tooltip>
                  ) : (
                    bankAccountDetails?.accountNumber
                  )}
                </div>
              </Col>
              <Col span={6}>
                <div>
                  <span
                    style={{
                      paddingRight: "10px",
                      color: "rgb(139, 143, 165)",
                    }}
                  >
                    IFSC Code:
                  </span>
                  {bankAccountDetails?.bankDetail?.ifsCode!}
                </div>
                <div>
                  <span
                    style={{
                      paddingRight: "16px",
                      color: "rgb(139, 143, 165)",
                    }}
                  >
                    Bank Name:
                  </span>
                  {bankAccountDetails?.bankDetail?.bankName!}
                </div>
              </Col>

              <Col span={5} style={{ display: "flex", justifyContent: "end" }}>
                <div style={{ paddingTop: "6px" }}>
                  <Button
                    onClick={() => {
                      setOpenModel({
                        type: "addChequeBook",
                        param: { id: "", type: AdjustBankType.undefined },
                      });
                    }}
                    type="primary"
                  >
                    Add Cheque Book
                  </Button>
                </div>
              </Col>
            </Row>
          </Card>

          <Card
            className="ca-card-body"
            style={{ boxShadow: "0px 0px 10px 0px #96A1C84D" }}
          >
            <div
              style={{
                height: `calc(100vh - 216px)`,
                // backgroundColor: "azure",
                overflowY: "auto",
              }}
            >
              {bank.id && (
                <>
                  <ChequeBooksTable
                    ledgerId={bank?.id}
                    setOpenModel={setOpenModel}
                    refresh={refresh}
                    setRefresh={setRefresh}
                  />
                </>
              )}
            </div>
          </Card>
        </Col>
      </Row>

      {confirmation && (
        <ConfirmationModal
          open={confirmation}
          onNo={() => setConfirmation(false)}
          onYes={() => deleteLedger()}
          text={`Are you sure to delete this "${bank.name}"`}
        />
      )}
      {/* -------------ADD Bank Account ----------*/}
      {openModel.type === "addBankAccount" && (
        <AddBankAccountModel
          open={openModel.type === "addBankAccount"}
          onCancel={() => setOpenModel({ type: "", param: "" })}
          bankAccountTrigger={() => setBankTrigger(!bankTrigger)}
          id={openModel.param?.id}
          curentBankAccountId={bank.id}
          allBankAccount={bankList}
        />
      )}
      {openModel.type === "addChequeBook" && (
        <AddChequeBookModal
          open={true}
          onCancel={() => setOpenModel({ type: "", param: "" })}
          id={openModel.param?.id}
          ledgerId={bank?.id}
          refresh={refresh}
          setRefresh={setRefresh}
        />
      )}
    </div>
  );
};

export default Cheque;
